import React from "react";
import FileTag from "./filetag";
import LimitedList from "components/LimitedList";

interface Props {
  files: server.dto.File[]
  onAddFilesClick: () => void
  editDisabled?: boolean
}

const FileList = ({ files, onAddFilesClick, editDisabled }: Props) => <div className="flex">
  <div className="grow1">
    <div className="ui blue labels">
      {files.length === 0 && RESX.File.NoFilesUploaded}
      <LimitedList
        items={files}
        renderItem={file => <FileTag key={file.id} file={file} />}
        renderExcess={nr => <a className="ui label" onClick={onAddFilesClick}>+{nr}</a>}
        limit={5}
        delimiter=""
      />
    </div>

  </div>

  {!editDisabled && <div>
    <a className="icon-ellipsis-h" onClick={onAddFilesClick}></a>
  </div>}
</div>;

export default FileList;
